// Lets the axios interceptor (plain JS, no React) tell <ApprovalProvider> that a request was answered with "approval
// requested" (HTTP 202): the provider shows a toast and refreshes what is waiting. It registers itself here on mount.
let announcer = null;

export const setApprovalAnnouncer = (fn) => { announcer = fn; };

export const announceApproval = (data) => { if (announcer) announcer(data); };
